import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "price-per-month" }
const _hoisted_2 = {
  key: 0,
  class: "price-square"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("sup", null, "2", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["estate-card__price", _ctx.priceClass])
  }, [
    (_ctx.ad.price)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("span", null, [
            (_ctx.isDeveloperProject)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('AdListItemPrice.price-from')), 1)
                ], 64))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.$filters.currency(_ctx.ad.price, _ctx.ad.currency)) + " ", 1),
            _createElementVNode("span", _hoisted_1, [
              (_ctx.isLease)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('AdListItemPrice.price-per-month-lease')), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.isRoommate)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('AdListItemPrice.price-per-month-roommate')), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.showPriceSquare && _ctx.ad.pricePerSquareMeter)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                _createTextVNode("(" + _toDisplayString(_ctx.$filters.currency(_ctx.ad.pricePerSquareMeter, _ctx.ad.currency)) + "/m", 1),
                _hoisted_3,
                _createTextVNode(")")
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(_ctx.$t(_ctx.isEstateAgency ? 'price.empty-agency' : 'price.empty')), 1)
        ], 64))
  ], 2))
}